import React from "react";
import {useRouter} from "next/router";
import cx from "classnames";
import {Button, Space} from "antd";
import {TExamKind} from "@/types/index";
import styles from "@/page-components/detail/Intro/styles.module.less";
import PCSignupBtn from "@/page-components/detail/Intro/pc_signup_btn";
import {judgeIsPExam} from "@/utils/index";

type THistoryPass = {
  type: TExamKind;
  isOrganizationAdmin?: boolean // 是否是组织管理员
  pass_link?: string;
  pass_tips: string;
}

const Gap: React.FC<{ gap: number }> = ({children, gap}) => {
  return <div style={{marginBottom: gap}}>{children}</div>
}

const HistoryPass: React.FC<THistoryPass> = ({isOrganizationAdmin,pass_tips,pass_link,type}) => {
  const router = useRouter();
  const renderIcon = () => {
    return '/img/detail/plan/pass_big.png';
  }
  const renderItem = () => {
    return (
      <>
        <Gap gap={8}>
          <p className={styles.signup_info_wrapper_body_text} dangerouslySetInnerHTML={{__html: pass_tips}} />
        </Gap>
        {pass_link && (
          <Gap gap={16}>
            <Space className={cx(styles.signup_info_wrapper_body_time_text, styles.gap)}>
              <p dangerouslySetInnerHTML={{__html: pass_link}}/>
            </Space>
          </Gap>
        )}
        <Space>
          {judgeIsPExam(type) && isOrganizationAdmin && (
            <PCSignupBtn/>
          )}
          <Button className={styles.simple_btn} onClick={() => {
            router.push('/verify');
          }}>证书&成绩查询</Button>
        </Space>
      </>
    )
  }


  return (
    <div className={styles.signup_info_wrapper}>
      <div className={styles.title}>报考信息</div>
      <div className={styles.signup_info_wrapper_body}>
        <img
          src={renderIcon()}
          alt="" className={styles.img}/>
        {renderItem()}
      </div>
    </div>
  )
}
export default HistoryPass;
